export default "__VITE_ASSET__zTgduSnH__"